module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2ca"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIC")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERNON")]), _vm._v(" walked into Sam’s Place, a seedy topless bar in the valley, and immediately fixed his gaze on Arliss Shepherd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arliss was not a pretty sight as he leaned against the bar, nursing a half-full bottle of beer. Long-faced with pale, pockmarked skin, and lank, shoulder-length yellow hair, he was skinny as a starving coyote and just as skittish. Nervous habits surrounded him—he chewed on his straggly hair, picked his teeth, rarely changed his underwear, and smelled of stale onions.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("In spite of his shortcomings, Arliss was not lacking in friends—a group of similar misfits hung out at Sam’s Place, with Arliss leading the pack. Sam, an obese man famous for only having one ball, ran his bar like a friendly club for losers. Regulars included Davey “the Animal,” Little Joe, and Big Mark Johansson. They were a motley crew, drawing solace from each other’s company and the fact that there was strength in numbers. Together they could kick ass. Alone they were useless, nothing more than a bunch of loud-mouthed failures. ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Which, as far as Eric Vernon was concerned, was a good thing, because men with no self-esteem were far easier to manipulate than men with balls. He’d discovered that in prison when he was doing time for manslaughter.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Manslaughter my ass,")]), _vm._v(" Eric thought as he approached Arliss at the bar. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I hit the scumbag with a two-by-four until he dropped dead in front of me. And not a moment too soon.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric Vernon was a nondescript man of medium height and slight build, with bland features and sandy brown hair cut short. He had the kind of face that blended in—the kind of face that nobody ever remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Except that skanky bitch remembered me all right,")]), _vm._v(" he thought sourly. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oh, yes, she remembered me so well that I served six miserable years in prison because of her.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first thing he’d done when he’d gotten out of the joint was taken care of her. Smashed her pointy face until it was no more than pulp. Then he’d burned her house down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The best revenge is deadly. Eric had learned that at an early age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately after dealing with the tattling bitch, he’d adopted a new identity and moved to California, eventually settling in L.A., where he’d gotten a job with a computer company—using a skill he’d mastered in jail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All this had taken place two years earlier, and no one had ever questioned who he was or where he came from. Which is exactly the way he’d planned it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A person does not sit in jail for six stinking years without making plans. And Eric had an agenda, an agenda he was getting ready to pursue.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be1e488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/pro.vue
// module id = 72
// module chunks = 0